var _path;
import * as React from "react";
function SvgComboInsightsHorizontalBorderNegative(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.495 33.234A2.5 2.5 0 012.5 30.785V7A1.5 1.5 0 014 5.5h52A1.5 1.5 0 0157.5 7v23.785a2.5 2.5 0 01-1.995 2.449l-25.202 5.193c-.2.041-.406.041-.606 0L4.495 33.234z"
  })));
}
export default SvgComboInsightsHorizontalBorderNegative;